import React, { useState, useEffect, useRef } from "react";
import { useInView } from "react-intersection-observer";
import "intersection-observer";
import { ErrorPlaceholder, EmptyPlaceholder } from "./placeholder";
import request from "../../../network/request";
import styles from "./index.module.scss";
import { IMainRecords } from "../types";
import useGetCh from "../../../hooks/useGetCh";
import useCurrentVeichle from "../../../hooks/useVehicle";
import { reportUserBehavior } from "../../../utils/common";
import RecordItem from "./components/recordItem";
import VehicleCard from "./components/VehicleCard";
import LoadingHomepage from "../../maintence/components/LoadingHomepage";
import { refreshPageByBack } from "../utils";
import { sendReport } from "../../../utils/reporter";
import useVehicleList, { IVehicle } from "../hooks/useVehicleList";
import useQuery from "../../../hooks/useQuery";

// const initialRecords = [
//   {
//     uuid: "", //主单uuid
//     mainOrderType: 0, //服务主单类型编码：100=移动；200=维保；300=结算
//     mainOrderTypeText: "", //服务主单类型名称
//     mainOrderStatus: 0, //服务主单状态编码： 1000=预约； 2000=环检； 3000=施工； 4000=结算； 5000=还车
//     mainOrderStatusText: "", //服务主单状态名称
//     serviceTimeTitle: "", //服务时间名称：预约时间，开始时间
//     serviceTime: 0, //服务时间
//     serviceAddressTitle: "", //服务地点名称：服务网点，服务地点
//     serviceAddress: "", //服务地点value
//     vin: "", //车架号
//     vehicleSeries: "", //车系
//     plateNumber: "", //车牌
//     uid: 0, //用户uid
//     actions: [
//       {
//         desc: "", //动作描述
//         text: "", //按钮文案
//         url: "" //跳转链接
//       }
//     ]
//   }
// ];

const initialRecords = [];

const PAGE_SIZE = 10;

export default function () {
  document.title = "服务记录";

  const ch = useGetCh();
  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingError, setIsLoadingError] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [loadMoreRef, loadMoreInView] = useInView();
  const currentPageRef = useRef(1);
  const totalPagesRef = useRef(0);
  const scrollYRef = useRef(0);
  const [isLoadingMore, setIsLoadingMore] = useState(false);

  const { currentVeichle: currentVeichleFromWindow } = useCurrentVeichle();
  const query = useQuery();

  const vinFromUrl = currentVeichleFromWindow?.vin || query.get("vin");
  const platenumFromUrl =
    currentVeichleFromWindow?.plateNumber || query.get("platenum");
  const {
    currentVehicle: currentVehicleFromHook,
    getUserVehicleAndList,
    vehicleList
  } = useVehicleList();
  const [currentVehicle, setCurrentVehicle] = useState<IVehicle | null>(null);

  const [mainOrderList, setMainOrderList] =
    useState<IMainRecords[]>(initialRecords);

  useEffect(() => {
    if (currentVehicleFromHook?.vin !== currentVehicle?.vin) {
      setCurrentVehicle(currentVehicleFromHook);
      requestMainOrderList(currentVehicleFromHook?.vin || "");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentVehicleFromHook]);

  console.log("currentVehicle", currentVehicle);
  useEffect(() => {
    getUserVehicleAndList(platenumFromUrl, vinFromUrl);
    sendReport({
      mcode: "服务记录访问量",
      point: "P11184`B001",
      type: "page"
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    refreshPageByBack();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!isLoading && !isLoadingError) {
      reportUserBehavior(
        {
          so: "J001002",
          mcode: "main_order_list",
          ch,
          pa: `status=success`
        },
        "page"
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading, isLoadingError]);

  // 翻页处理
  useEffect(() => {
    console.log(loadMoreInView);
    if (
      loadMoreInView &&
      totalPagesRef.current > currentPageRef.current &&
      !isLoadingMore
    ) {
      scrollYRef.current =
        document.documentElement.scrollTop || document.body.scrollTop;
      loadAnotherRecord();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loadMoreInView]);

  const loadAnotherRecord = async () => {
    setIsLoadingMore(true);
    currentPageRef.current += 1;
    await requestMainOrderList(currentVehicle?.vin || "");
    setIsLoadingMore(false);
  };

  const getInitOrderList = async () => {
    setIsLoading(true);
    setIsLoadingError(false);
    await requestMainOrderList(currentVehicle?.vin || "");
    setIsLoading(false);
  };

  const requestMainOrderList = async (vin: string) => {
    try {
      const { pages, records }: any = await request(
        "serviceOrder/qryOrderByType",
        {
          currentPage: currentPageRef.current,
          size: PAGE_SIZE,
          vin
        },
        "POST"
      );
      reportUserBehavior({
        so: "J001002",
        mcode: "main_order_list__req_get_main_order_list_success",
        ch,
        pa: `status=success`
      });

      console.log(records, "子单数据");
      totalPagesRef.current = pages || 0;

      if (currentPageRef.current === 1) {
        setMainOrderList(records);
      } else {
        setMainOrderList([...mainOrderList, ...records]);
      }
      setIsLoading(false);

      // window.scrollTo({ top: scrollYRef.current, behavior: "smooth" });
    } catch (err) {
      reportUserBehavior({
        so: "J001002",
        mcode: "main_order_list__req_get_main_order_list_error",
        ch,
        pa: `status=error\`errMessage=${(err as any)?.message}`
      });
      setIsLoading(false);
      setIsLoadingError(true);
      setErrorMsg((err as any).message || "获取服务订单失败，请稍后重试");
    }
  };

  if (isLoading) {
    return <LoadingHomepage></LoadingHomepage>;
  }

  if (isLoadingError) {
    reportUserBehavior(
      {
        so: "J001002",
        mcode: "main_order_list",
        ch,
        pa: `status=error`
      },
      "page"
    );
    return (
      <ErrorPlaceholder
        message={errorMsg}
        getData={getInitOrderList}
      ></ErrorPlaceholder>
    );
  }

  const onSwitchCar = (t: IVehicle) => {
    console.log("onSwitchCar", t);

    setCurrentVehicle(t);
    setIsLoading(true);
    currentPageRef.current = 1;
    totalPagesRef.current = 0;
    setMainOrderList([]);
    requestMainOrderList(t.vin);
  };

  const showVehicleCard = vehicleList?.length > 1;

  return (
    <div className={styles.pageOrderList}>
      {showVehicleCard && (
        <div className={styles.carLicenseSwitch}>
          <VehicleCard
            selectedVehicle={currentVehicle}
            onSwitchCar={onSwitchCar}
          ></VehicleCard>
        </div>
      )}
      {totalPagesRef.current > 0 ? (
        <div
          className={
            showVehicleCard
              ? styles.orderListContainerWithVehicle
              : styles.orderListContainer
          }
        >
          {mainOrderList?.map((orderItem) => (
            <RecordItem
              content={orderItem}
              key={orderItem.orderCode}
            ></RecordItem>
          ))}
          <div className={styles.loadMoreRecord} ref={loadMoreRef}>
            {isLoadingMore && (
              <div className={styles.titleAndOpt}>
                <div className={styles.refreshBtn}></div>
                <p className={styles.title}>正在加载...</p>
              </div>
            )}
          </div>
        </div>
      ) : (
        <EmptyPlaceholder text="暂无服务记录"></EmptyPlaceholder>
      )}
    </div>
  );
}
